import React from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';
import { HEADER_HEIGHT } from '../constants';

interface HeaderBackgroundProps extends FlexProps {
  className?: string;
  isSignedOutWeb?: boolean;
  children?: React.ReactNode;
}

export const HeaderBackground: React.FC<HeaderBackgroundProps> = ({
  isSignedOutWeb,
  children,
  ...rest
}) => (
  <Flex
    position="fixed"
    alignItems="center"
    height={`${HEADER_HEIGHT}px`}
    width="100%"
    zIndex="banner"
    bgColor={isSignedOutWeb ? 'M.10' : undefined}
    {...rest}
  >
    {children}
  </Flex>
);
